import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faArrowsLeftRight,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import "./PieChart.css";

const NewUsersBox = ({users}) => {



  return (
    <div style={{ display: "flex", justifyContent: "space-around" }}>
      <div style={{ width: "30%", marginTop: "1em" }}>
        <FontAwesomeIcon style={{ width: "20%" }} icon={faUserPlus} />
        <h3>{users.totalUsers}</h3>
        <h5>Total Users</h5>
      </div>

      <div></div>
      <div style={{ height: "10vh", width: "30%", marginTop: "1em" }}>
        <div class="pie-chart">
          <div class="inner-circle">
            {users.usersPercentageChange > 0 ? (
              <FontAwesomeIcon
                icon={faArrowTrendUp}
                style={{ color: "#26c030" }}
              />
            ) : (
              <FontAwesomeIcon icon={faArrowsLeftRight} size='lg' style={{color: "#f4da2f",}} />
            )}
          </div>
        </div>
        <h5 className='percentage'>{users.usersPercentageChange > 0 ? users.usersPercentageChange + "%" : ''}</h5>
      </div>
    </div>
  );
};

export default NewUsersBox;
